import { Component, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';

@Component({
    selector: 'ifbp-test-scenarios',
    templateUrl: './test-scenarios.component.html',
    styleUrls: ['./test-scenarios.component.scss'],
    standalone: false
})
export class TestScenariosComponent {
  @Output() navigate = new EventEmitter<string>();
  @ViewChild('toc') tableOfContents: ElementRef;
  
  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
